<!--我的融资-->
<template>
  <div class="totalList_container">
    <Form ref="form">
      <Row>
        <Col :xs="{span:24}" style="margin-bottom:30px;display: flex">
          <FormItem style="margin-top:17px;width:10%">
            <Select placeholder="业务状态" v-model="form.state">
              <Option value="">全部状态</Option>
              <Option value="wait_clerk_check">等待业务员审批</Option>
              <Option value="wait_risk_check">等待风控部审批</Option>
              <Option value="wait_top_manager_check">等待总经理审批</Option>
              <Option value="success">审批成功</Option>
              <Option value="fail">审批失败</Option>
              <Option value="repaying">还款中</Option>
              <Option value="overdue">已逾期</Option>
              <Option value="dunning">催款中</Option>
              <Option value="prosecution">起诉中</Option>
              <Option value="complete">已完成</Option>
            </Select>
          </FormItem>
          <Button @click="handleSubmit" class="buttons">搜&emsp;索</Button>
          <Button style="background:#2975E6;height:30px;border:0;color:#ffffff;margin-top:20px;margin-left:1%" @click="handleDownload">导出Excel</Button>
        </Col>
        <Col :xs="{span:24}">
          <div class="mtable">
            <Table border :content="self" :columns="columns7" :data="pagination.items"></Table>
          </div>
        </Col>
      </Row>
    </Form>
    <div class="pagination-list" id="pagination-list">
      <Page
        :total="pagination.total" show-total show-sizer class-name="pagination"
        @on-change="pageChange"
        :page-size-opts="[10,20,30]"
        :page-size="10"
        :current="pagination.page"
        @on-page-size-change="changeSize">
      </Page>
    </div>
  </div>
</template>
<script>
  import ApiClient from '@/api/ApiClient'
  export default {
    name: 'totalList',
    data() {
      return {
        form: {
          page: 1,
          size: 10,
          state: '',
          time: null,
          overTime:null,
        },
        pagination: {},
        self: this,
        excelData: {},
        columns7: [
          {
            align:'center',
            title:'公司名称',
            key:'company',
            minWidth:220,
            render: (h, params) => {
              return h('div', {
                style:{fontWeight:'bold'}
              }, params.row.company)
            }
          },
          {
            align:'center',
            title:'业务编号',
            key:'businessNo',
            minWidth:180
          },
          {
            align:'center',
            title:'创建时间',
            key:'createdAt',
            minWidth:160,
            render: (h, params) => {
              return h('div', [
                h('div', {}, this.$moment(params.row.createdAt).format('YYYY-MM-DD'))
              ])
            }
          },
          {
            align:'center',
            title:'保理金额',
            key:'money',
            minWidth:160,
            render: (h, params) => {
              return h('div', [
                h('div', {},
                  `￥${params.row.money.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}`)
              ])
            }
          },
          {
            align:'center',
            title:'期限',
            key:'limitTime',
            minWidth:100,
          },
          {
            align:'center',
            title:'手续费',
            key:'manageFee',
            minWidth:160,
            render: (h, params) => {
              return h('div', [
                h('div', {},
                  `￥${params.row.manageFee.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}`)
              ])
            }
          },
          {
            align:'center',
            title:'利息',
            key:'interest',
            minWidth:160,
            render: (h, params) => {
              if (params.row.interest){
                return h('div', {
                }, `￥${params.row.interest.toFixed(2)}`)
              } else {
                return h('div',{}, `￥${Number(0).toFixed(2)}`)
              }
            }
          },
          {
            align:'center',
            title:'展期利息',
            key:'delayInterest',
            minWidth:160,
            render:(h,params)=>{
              if (params.row.delayInterest){
                return h('div', {
                }, `￥${params.row.delayInterest.toFixed(2)}`)
              } else {
                return h('div',{}, `￥${Number(0).toFixed(2)}`)
              }
            }
          },
          {
            align:'center',
            title:'罚息',
            key:'fee',
            minWidth:160,
            render:(h,params)=>{
              if(params.row.fee){
                return h('div',{
                },`￥${params.row.fee.toFixed(2)}`)
              }else{
                return h ('div',{},`￥${Number(0).toFixed(2)}`)
              }
            }
          },
          {
            align:'center',
            title:'保理方',
            key:'realName',
            minWidth:220
          },
          {
            align:'center',
            title:'类型',
            key:'productTypeName',
            minWidth:160
          },
          {
            align: 'center',
            title: '业务状态',
            key: 'state',
            minWidth:160
          },
          {
            title: '操作',
            key: 'details',
            align: 'center',
            minWidth:160,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    background: 'none',
                    color: '#ff9600',
                    border: 'none'
                  },
                  on:{
                    click:()=>{
                      this.$router.push(
                        {name: 'nototalList', query: {id: params.row.id,businessRepayDetailId:params.row.businessRepayDetailId}},
                      )
                    }
                  }
                }, '详情'),
                (params.row.state == '未结算' && params.row.stagingState == null) ?
                  h('Button',{
                    props:{
                      type:'primary'
                    },
                    style:{
                      background: 'none',
                      color: '#ff9600',
                      border: 'none'
                    },
                  },'还款'):  h('Button', {
                    props: {
                      type: 'primary'
                    },
                    style: {
                      background: 'none',
                      color: '#ff9600',
                      border: 'none'
                    },
                    on: {
                      click: () => {
                        this.$router.push(
                          {name: 'repayment', query: {id: params.row.id}},
                        )
                      }
                    }
                  })
              ])
            },
          }],
      }
    },
    methods: {
      initData() {
        if (this.form.createdAt) {
          this.form.createdAt = this.$moment(this.form.createdAt).format('YYYY-MM-DD')
        }
        ApiClient.get('/desktop/businessLoan/myLoanList.do', this.form).then(data => {
          this.pagination = data
          for(let i=0;i<data.items.length;i++){
            if(data.items[i].state=='待业务员审批' ||data.items[i].state=='待风控部审批' ||data.items[i].state=='待总经理审批'){
              data.items[i].state='审批中'
            }
          }
        })
        ApiClient.get('/desktop/businessLoan/myLoanList.do', Object.assign({},this.table,{page:1,size:99999999})).then(data => {
          this.excelData = data;
        })
      },
      handleSubmit() {
        this.form = Object.assign({}, this.form, {page: 1, size: 10});
        this.initData()
      },
      pageChange(v) {
        this.form.page = v;
        this.initData()
      },
      changeSize(size) {
        this.form.size = size;
        this.initData()
      },
      handleDownload() {
        require.ensure([], () => {
          const { export_json_to_excel } = require('@/excel/Export2Excel')
          const tHeader = ['公司名称', '业务编号', '创建时间','罚息','利息','期限','手续费','保理金额','玻璃方','类型','业务状态']
          const filterVal = ['company','businessNo','createdAt','fee','interest','limitTime','manageFee','money','realName','productTypeName','state']
          const list = this.excelData.items;
          for(let i=0;i<list.length;i++){
            list[i].createdAt=this.$moment(list[i].createdAt).format('YYYY-MM-DD');
          }
          const data = this.formatJson(filterVal, list)
          export_json_to_excel(tHeader, data, '我的保理列表')
        })
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
      },
    },
    computed: {},
    mounted() {
      this.initData()
    }
  }
</script>
<style lang="less" scoped>
  .totalList_container {
    .pagination-list {
      margin: 20px 0;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: end;
      -ms-flex-pack: end;
      justify-content: center;
    }
    #pagination-list .pagination .ivu-page-item-active {
      background-color: transparent;
    }
    .buttons{
      min-width:80px;
      margin-top: 20px;
      margin-left: 25px;
      background:#FF9600;
      border:0;
      color:#ffffff;
      height:30px;
    }
  }
  .mtable {
    height: auto;
    margin-top: 20px;
    .ivu-table-wrapper {
      border-color: #bbcade;
      overflow-y:scroll;
    }
    .ivu-table-border th, .ivu-table-border td {
      text-align: center;
      border-color: #bbcade;
    }
    .ivu-table-border th{
      background-color: #e9eff7;
    }
    .ivu-table:before {
      background-color: #bbcade;
    }
    .ivu-table:after {
      background-color: #bbcade;
    }
    thead {
      .ivu-table-column-center {
        background-color: #e9eff7;
      }
    }}
</style>



// WEBPACK FOOTER //
// src/pages/financingManagement/myFinancing.vue